import AppRecord from './AppRecord.js'

class Price extends AppRecord {
  get primary_key(){
    return this.issue_id+','+this.date
  }
}

export default Price
